import type { HoverLayer } from 'api/field'

// Highest priority first.
export const HOVER_LAYER_PRIORITY: HoverLayer[] = [
  'raw_points',
  'corrected_points',
  'swath',
]

interface VisibleLayer {
  name?: string
  layerName?: string
  harvestId?: number | string
}

/** The inspectable layer the user sees on top for this harvest, if any. */
export function pickHoverLayer(
  wmsLayers: VisibleLayer[] | null | undefined,
  harvestId: number | null | undefined,
): HoverLayer | null {
  if (!wmsLayers || harvestId == null) return null
  const visible = new Set(
    wmsLayers
      .filter((l) => String(l.harvestId) === String(harvestId))
      .map((l) => l.name ?? l.layerName),
  )
  return HOVER_LAYER_PRIORITY.find((layer) => visible.has(layer)) ?? null
}
